import { GetOfferRequestsState } from './getOfferRequests.types'

const initialState: GetOfferRequestsState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
